import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from "react-router-dom";
import ReCAPTCHA from "react-google-recaptcha";
import Api from '../../helpers/api';
import { toast } from 'react-toastify';
import './style.css'
const api = new Api();

const Register = () => {

    const navigate = useNavigate();
    const [errors, setErrors] = useState({})
    const [isLoading, setIsLoading] = useState(false)
    const [showPassword, setShowPassword] = useState(false)
    const [formData, setFormData] = useState({ email: "", password: "" })

    const [inputPassword, setInputPassword] = useState({
        type: 'password',
        icon: 'far fa-eye icon',
    })

    const handleInput = (e, name) => {
        setFormData({ ...formData, [name]: e.target.value })
    }

    const onSubmit = () => {
        if (!captchaValidation(formData)) {
            return
        }

        setIsLoading(true)
        api.register(formData)
            .then(response => {
                setIsLoading(false)
                navigate("/thesis/login");
                toast.success(response?.data?.meta?.message)
            }).catch((error) => {
                const { data, status } = error.response
                setErrors(data?.meta?.error)
                setIsLoading(false)
                toast.error(data?.meta?.message)
            })
    };

    const handleChangeEyeIcon = (icon) => {
        if (icon == 'far fa-eye icon') {
            setInputPassword({
                type: 'text',
                icon: 'far fa-eye icon fa-eye-slash',
            })
            return
        }

        setInputPassword({
            type: 'password',
            icon: 'far fa-eye icon',
        })
    }

    const handleChangeCaptcha = (value) => {
        setErrors({})
        setFormData({ ...formData, ['g_recaptcha_response']: value })
    }

    const captchaValidation = (formData) => {
        if (!formData?.g_recaptcha_response) {
            setErrors({ recaptcha: 'Captcha wajib diisi' })
            return false
        }

        return true
    }

    return (
        <div style={styles.bgLogin} className='p-15'>
            <div className='row'>
                <div className='col-lg-4 col-md-12 col-sm-12 col-xs-12'></div>
                <div className='col-lg-4 col-md-12 col-sm-12 col-xs-12'>
                    <p className='text-white text-center display-6 fw-bold'>Create an Account</p>

                    <div className='input-group mt-15'>
                        <span className='input-group-text' style={{ backgroundColor: '#FFFFFF' }}><i className='bi bi-person-circle'></i></span>
                        <input
                            onChange={value => handleInput(value, 'nama_depan')}
                            type='text'
                            className='form-control'
                            placeholder='Nama Depan'
                            style={{ borderLeft: 'none' }} />
                    </div>
                    {errors?.nama_depan ? <p className='text-danger mt-1'>{errors?.nama_depan}</p> : null}

                    <div className='input-group mt-5'>
                        <span className='input-group-text' style={{ backgroundColor: '#FFFFFF' }}><i className='bi bi-person-circle'></i></span>
                        <input type='text'
                            onChange={value => handleInput(value, 'nama_belakang')}
                            className='form-control'
                            placeholder='Nama Belakang'
                            style={{ borderLeft: 'none' }} />
                    </div>
                    {errors?.nama_belakang ? <p className='text-danger mt-1'>{errors?.nama_belakang}</p> : null}

                    <div className='input-group mt-5'>
                        <span className='input-group-text' style={{ backgroundColor: '#FFFFFF' }}><i className='bi bi-envelope'></i></span>
                        <input
                            onChange={value => handleInput(value, 'email')}
                            type='text'
                            className='form-control'
                            placeholder='Email'
                            style={{ borderLeft: 'none' }} />
                    </div>
                    {errors?.email ? <p className='text-danger mt-1'>{errors?.email}</p> : null}

                    <div className='input-group mt-5'>
                        <span className='input-group-text' style={{ backgroundColor: '#FFFFFF' }}><i className='fa fa-lock'></i></span>
                        <input
                            type={inputPassword.type}
                            onChange={value => handleInput(value, 'password')}
                            className='form-control'
                            placeholder='Password'
                            style={{ borderLeft: 'none', borderRight: 'none' }}
                        />
                        <span
                            className='input-group-text'
                            style={{ backgroundColor: '#FFFFFF', cursor: 'pointer' }}
                            onClick={() => handleChangeEyeIcon(inputPassword.icon)}>
                            <i className={inputPassword.icon}></i>
                        </span>
                    </div>
                    {errors?.password ? <p className='text-danger mt-1'>{errors?.password}</p> : null}

                    <div className='pt-5'>
                        <ReCAPTCHA
                            className='g-recaptcha'
                            sitekey="6Lf3qh8qAAAAAAmCYQOBXog8koATjbM4w7HZBGo2"
                            onChange={handleChangeCaptcha}
                        />
                        {errors?.recaptcha ? <p className='text-danger mt-1'>{errors?.recaptcha}</p> : null}
                    </div>

                    <button
                        className='btn btn-primary mt-10 rounded-pill w-100 fw-bold'
                        onClick={() => onSubmit()}
                        disabled={isLoading}
                    >{isLoading ? 'Loading...' : 'Daftar'}</button>

                    <div className='d-flex justify-content-center mt-10' style={{ display: 'inline-flex', alignItems: 'center' }}>
                        <p className='text-white'>Kembali?</p>
                        <Link to={'/thesis/login'} className='text-white fw-bold mx-3'>Login</Link>
                    </div>

                    <div className='text-center text-white mt-10 mb-10' style={{ fontSize: '10.66px' }}>
                        <p>By continuing, you acknowledge that you have read and understood, and agree to telenta LPDP Terms of Service and Privacy Policy.</p>
                    </div>


                    <p className='text-center text-white mt-15'>© 2024 LPDP. All Rights Reserved. Terms & Privacy</p>
                </div>
                <div className='col-lg-4 col-md-12 col-sm-12 col-xs-12'></div>
            </div>
        </div>
    );
};

const styles = {
    bgLogin: {
        backgroundImage: 'linear-gradient(180deg, rgba(25, 25, 25, 0.73) 0%, rgba(0, 0, 0, 0.9) 100%)',
        marginTop: '-70px',
        borderRadius: '60px 60px 0 0'
    },
}

export default Register;